
export const pricing = {
  'request.pricing': '가격 문의',
  'view.pricing': '가격 보기',
  'product.pricing': '제품 가격',
};
